import { ReportData, FileAttachment } from './reportTypes';

export const getRiskLevelColor = (riskLevel: number): { backgroundColor: string, color: string } => {
    if (riskLevel < 3) return { backgroundColor: 'white', color: 'black' };
    if (riskLevel < 6) return { backgroundColor: 'yellow', color: 'black' };
    if (riskLevel < 12) return { backgroundColor: 'orange', color: 'black' };
    return { backgroundColor: 'red', color: 'white' };
};

export const getRiskLevelText = (riskLevel: number): string => {
    if (riskLevel < 3) return 'DÜŞÜK';
    if (riskLevel < 6) return 'ORTA';
    if (riskLevel < 12) return 'YÜKSEK';
    return 'KRİTİK';
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Failed to convert blob to base64'));
            }
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
    });
};

export const getCoverPhotoId = (reportData: ReportData): string | null => {
    if (!reportData?.pinInfo?.fileAttachments) return null;
    const coverPhoto = reportData.pinInfo.fileAttachments.find(
        attachment => attachment.fileName.toLowerCase().includes(`cover${reportData.pinInfo.Id.toLowerCase()}`)
    );
    return coverPhoto?.id || null;
};

export const getMapImage = (reportData: ReportData): string | null => {
    if (!reportData.pinInfo.fileAttachments) return null;
    const mapFiles = reportData.pinInfo.fileAttachments.filter(
        attachment => attachment.fileName.toLowerCase().includes('harita')
    );
    if (mapFiles.length === 0) return null;
    const getMapNumber = (fileName: string) => {
        const match = fileName.match(/harita-(\d+)/i);
        return match ? parseInt(match[1]) : 0;
    };
    const latestMap = mapFiles.reduce((latest, current) => {
        const latestNum = getMapNumber(latest.fileName);
        const currentNum = getMapNumber(current.fileName);
        return currentNum > latestNum ? current : latest;
    }, mapFiles[0]);
    return latestMap?.id || null;
};